/**
 * 商品詳細ページで、取り消し線つきの元値をオプション選択に連動させる。
 *
 * Globo Product Options は販売価格 ([data-gpo-product-unit-price]) だけを書き換えるため、
 * 元値が初期値のまま取り残される。オプションの加算額は元値にも同じだけ乗るものとして
 *   元値 = 初期元値 + (現在の販売価格 - 初期販売価格)
 * を表示する。値引き額は変わらない。
 */
(function () {
  'use strict';

  var SALE_SELECTOR = '[data-gpo-product-unit-price]';
  var COMPARE_SELECTOR = '[data-gpo-product-compare-at-price]';

  function toYen(text) {
    var digits = (text || '').replace(/[^0-9]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function format(yen) {
    return '¥' + yen.toLocaleString('ja-JP');
  }

  var compareEl = document.querySelector(COMPARE_SELECTOR);
  var saleEl = document.querySelector(SALE_SELECTOR);
  if (!compareEl || !saleEl) return;

  var baseCompare = toYen(compareEl.getAttribute('data-amount') || compareEl.textContent);
  var baseSale = toYen(saleEl.getAttribute('data-amount') || saleEl.textContent);
  if (!baseCompare || !baseSale || baseCompare <= baseSale) return;

  var discount = baseCompare - baseSale;

  function sync() {
    // Globo がオプション選択で価格要素ごと作り直すことがあるので毎回引き直す
    var sale = document.querySelector(SALE_SELECTOR);
    var compare = document.querySelector(COMPARE_SELECTOR);
    if (!sale || !compare) return;

    var current = toYen(sale.textContent);
    if (!current) return;

    var next = current + discount;
    if (toYen(compare.textContent) === next) return;

    compare.textContent = format(next);
    compare.setAttribute('data-amount', next.toLocaleString('ja-JP'));
  }

  var observer = null;
  function observe() {
    var sale = document.querySelector(SALE_SELECTOR);
    if (!sale) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(sync);
    observer.observe(sale, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-amount']
    });
  }

  function refresh() {
    sync();
    observe();
  }

  refresh();
  document.addEventListener('change', function () { setTimeout(refresh, 100); }, true);
  document.addEventListener('click', function () { setTimeout(refresh, 100); }, true);
})();
